<template>
  <div class="changeContract">

  </div>
</template>
<script>
import { Toast } from 'vant';
export default {
  name: 'changeContract',
  data() {
    return {
      baseurl : null,
      id : null,
      token : null,
      flag: null,
      signingStatus : null,
      contractNum : null,
      templateNumber : null,
    }
  },
  created() {
    console.log(this.$route,'creted')
    // debugger
    // if(this.$route.query.baseurl.includes('sassgclme')){
    //   this.baseurl = "https://sass.gclme.com"
    // }else{
    //   this.baseurl = "https://sasstest.gclme.com"
    // }
    // this.token=this.$route.query.token ? 'bearer ' + this.$route.query.token : "bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX25hbWUiOiIxODEwMDUiLCJzY29wZSI6WyJhbGwiXSwic2luZ2xlTG9naW4iOiIyIiwiZXhwIjoxNjYxNDUxNzkwLCJhdXRob3JpdGllcyI6WyJhYSJdLCJqdGkiOiJlZTdkZjA3ZS0wNDc2LTQ2YWQtODA5OS02MWQyNmY1YWUzMTEiLCJjbGllbnRfaWQiOiJhZG1pbiIsInRva2VuIjoiZ2NsbG9naW5fdG9rZW5fOWUxNmExYjAyYzgxNGI3NTg2MWM3NTAyY2JmZDNiYzEifQ.O7gcJ2YvMvIhkEDPEOB1eWBw-ucK3hU380yFiWtfll-tJCJNtO8L_S4oKQL3cyRBsOPpUtdpot5GTZtVs3JOeSsKA_gV3ll9npKaUiOc2PGojzEmYXwJNrJzDRjNMb721sgESoYobZWc6ilCZG5r0EVhbRhiwg3-l6wQLe1_QP60Grf4SQ1a-Jlg7iMp7jdS_sivC0i80E_PibTfpoIv_hPdEfXoQe7DJcE0BRNpdcke0pN7dG85iI86lXY6m5E02tyvclivnj549Rg7vuRL351cnRILLnrZWxImXNGErsya1ZNWSeaMVbz77FwneSYvvk2VDIcdOU7mBVu9dyqvIg";
    // this.id=this.$route.query.id ? this.$route.query.id : null;
    // this.flag = this.$route.query.flag ? this.$route.query.flag : null;
    // this.signingStatus = this.$route.query.signingStatus ? this.$route.query.signingStatus : null;
    // this.templateNumber = this.$route.query.templateNumber ? this.$route.query.templateNumber : null;
    // this.contractNum = this.$route.query.contractNum ? this.$route.query.contractNum : null;



    // this.id=this.getQueryString('callid');
    // this.token= 'bearer ' + this.getQueryString('token');
    // if(this.getQueryString('baseurl') && this.getQueryString('baseurl') == "1"){
    //   this.baseurl = "https://sass.gclme.com"
    // }else{
    //   this.baseurl = "https://sasstest.gclme.com"
    // }

    this.id=this.GetRequest('callid').callid;
    this.token= 'bearer ' + this.GetRequest('token').token;
    if(this.GetRequest('baseurl').baseurl == "1"){
      this.baseurl = "https://sass.gclme.com"
    }else{
      this.baseurl = "https://sasstest.gclme.com"
    }

    // this.flag = this.getQueryString('flag');
    // this.signingStatus = this.getQueryString('callsigningStatus');
    // this.templateNumber = this.getQueryString('calltemplateNumber');
    // this.contractNum = this.getQueryString('callcontractNum');

    this.changeContract()
  },
  mounted() {
    console.log(this.$route,'mouted')
  },
  methods: {
    // 获取url参数
    getQueryString (name) {
      let reg = new RegExp('(^|QQQQQ)' + name + '=([^QQQQQ]*)(&|$)', 'i');
      let r = window.location.search.substr(1).match(reg);
      if (r[2].indexOf("QQQQQ") != -1) {

        var str = r[2].substr(1);
        return str.split("QQQQQ")[0];
      }
      if (r != null) return unescape(r[2]);
      return null;
    },
    GetRequest() {

      var url = location.search; //获取url中"?"符后的字串

      var theRequest = new Object();

      if (url.indexOf("?") != -1) {

        var str = url.substr(1);
        var strs = str.split("QQQQQ");

        for(var i = 0; i < strs.length; i ++) {

          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    },
    changeContract(){
      Toast.loading({
        message: '更改合同状态中...',
        forbidClick: true,
        duration : 0
      });
      let _this = this;
      var header ={
        'X-Access-Token': ''
      }
      if(this.token){
        header ={
          'authorization': this.token
        }
      }
      this.$http({
        method : 'post',
        url : `${this.baseurl}/api/concludecontract/GclConcludeContract/updateContract`,
        headers:header,
        data:{
          id:this.id,
          signingStatus:'1'
        }
      }).then(({ data }) => {
        if(data.code == 200){
          Toast.loading({
            message: '合同状态更改成功,正在为您跳转',
            forbidClick: true,
            duration : 0
          });
        }else{
          Toast.fail('合同状态更改失败!');
        }
        this.goDetail();
      })
    },
    goDetail(){
      wx.miniProgram.getEnv(function(res){
        console.log(res)
          if (res.miniprogram){
            console.log(res.miniprogram)
            // wx.miniProgram.redirectTo({url: "packageC/pages/contract/contractDetail?id="+ this.id +"&signingStatus="+ this.signingStatus +"&flag="+ this.flag + "&templateNumber=" + this.templateNumber + "&contractNum=" + this.contractNum});
            wx.miniProgram.redirectTo({url: "/packageC/pages/contract/contractList"});
          }
      });
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../../common/stylus/mixin.styl'
</style>



// WEBPACK FOOTER //
// changeContract.vue?24872dff